import React from 'react';

function cleanPhone(phone: string) {
  return phone.replace(/[^\d]/g, '');
}

function getValidNumber(phone: string) {
  if (phone.length === 10 || phone.length === 11) return `55${phone}`;

  return phone;
}

function formatPhone(phone: string) {
  if (phone.length < 10) return phone;
  return phone.replace(/^(\d{2})(\d{4,5})(\d{4}).*/, '($1) $2-$3');
}

type WhatsAppLinkProps = {
  phone: string;
  children?: React.ReactNode;
  stylesProps?: string;
};

const defaultLinkClass = 'text-(--uizz-antd-color-success) underline';

const WhatsAppLink = ({ phone, children, stylesProps }: WhatsAppLinkProps) => {
  if (phone?.includes('***')) return <>{phone}</>;

  const isNewFormat = phone?.startsWith('+');
  const isBrazilianPhone = phone?.startsWith('+55') || phone?.startsWith('55');

  if (isNewFormat && !isBrazilianPhone) return <>{phone}</>;

  const cleanPhoneValue = cleanPhone(phone);
  const phoneValue = isBrazilianPhone ? cleanPhoneValue.replace('55', '') : cleanPhoneValue;

  if (isBrazilianPhone) {
    return (
      <a
        href={`https://api.whatsapp.com/send?phone=${getValidNumber(phoneValue)}`}
        target='_blank'
        rel='noopener noreferrer'
        className={stylesProps ?? defaultLinkClass}
      >
        {children ? children : formatPhone(phoneValue)}
      </a>
    );
  }

  return <>{children ? children : `${phoneValue.includes('+') ? '' : '+'}${phoneValue}`}</>;
};

export default WhatsAppLink;
